var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClearOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.5C6.11929 7.5 5 8.61929 5 10V32.5C5 33.8807 6.11929 35 7.5 35H32.5C33.8807 35 35 33.8807 35 32.5V10C35 8.61929 33.8807 7.5 32.5 7.5H7.5ZM2.5 10C2.5 7.23858 4.73858 5 7.5 5H32.5C35.2614 5 37.5 7.23858 37.5 10V32.5C37.5 35.2614 35.2614 37.5 32.5 37.5H7.5C4.73858 37.5 2.5 35.2614 2.5 32.5V10Z",
    fill: "#08152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C10.6904 2.5 11.25 3.05964 11.25 3.75V6.25C11.25 6.94036 10.6904 7.5 10 7.5C9.30964 7.5 8.75 6.94036 8.75 6.25V3.75C8.75 3.05964 9.30964 2.5 10 2.5ZM30 2.5C30.6904 2.5 31.25 3.05964 31.25 3.75V6.25C31.25 6.94036 30.6904 7.5 30 7.5C29.3096 7.5 28.75 6.94036 28.75 6.25V3.75C28.75 3.05964 29.3096 2.5 30 2.5ZM2.5 12.5C2.5 11.8096 3.05964 11.25 3.75 11.25H36.25C36.9404 11.25 37.5 11.8096 37.5 12.5C37.5 13.1904 36.9404 13.75 36.25 13.75H3.75C3.05964 13.75 2.5 13.1904 2.5 12.5Z",
    fill: "#08152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClearOutline);
export default __webpack_public_path__ + "static/media/calendar-clear-outline.c1776ff0e203384f218066a20ac0aeb5.svg";
export { ForwardRef as ReactComponent };